import { MxheroShareConfig } from "@dashboard-v3/api";
import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  RadioGroupProps,
  Typography,
} from "@material-ui/core";
import { useTranslation } from "react-i18next";

interface RetentionProps {
  disabled: boolean;
  value: string;
  onChange: (update: Partial<MxheroShareConfig>) => void;
}

enum Retention {
  OneYear = "ONE_YEAR",
  Permanent = "PERMANENT",
}

export default function RetentionOptions(props: RetentionProps) {
  const { t } = useTranslation("mxheroShares");
  const { value, disabled } = props;

  const onChange: RadioGroupProps["onChange"] = e => {
    const { value } = e.target;
    props.onChange({ retention: value as Retention });
  };

  return (
    <FormControl fullWidth disabled={disabled}>
      <Typography variant="subtitle2">
        {t("settings.retention.title")}
      </Typography>
      <RadioGroup
        name="retention"
        style={{ flexDirection: "row" }}
        value={value}
        onChange={onChange}
      >
        <FormControlLabel
          control={<Radio color="primary" size="small" />}
          label={t(`settings.retention.${Retention.OneYear}`)}
          value={Retention.OneYear}
        />
        <FormControlLabel
          control={<Radio color="primary" size="small" />}
          label={t(`settings.retention.${Retention.Permanent}`)}
          value={Retention.Permanent}
        />
      </RadioGroup>
    </FormControl>
  );
}
